module.exports = __webpack_public_path__ + "static/media/sad-emoji.d1eebbf1.gif";